/**
 * @module PointsService
 * @remarks RTK Query service for fetching customer points data
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * API service for fetching customer points
 */
export const pointsApi = createApi({
  reducerPath: "pointsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("auth_token");
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  tagTypes: ["Points"],
  endpoints: (builder) => ({
    getPoints: builder.query<number, string>({
      query: (customerId) => ({
        url: "data/kunden",
        method: "POST",
        body: {
          where: { id: Number(customerId.replace(/[a-zA-Z]/g, '')) },
          fields: {
            kundenkarten: ['punktestand']
          }
        },
      }),
      // Transform response to extract points value
      transformResponse: (response: any[]) => {
        const customerData = response[0]?.kunden;
        const points = Number(
          customerData?.kundenkarten?.filter(
            (karte: any) => 'punktestand' in karte
          )?.[0]?.punktestand
        ) || 0;
        return points;
      },
      providesTags: ["Points"],
    }),
  }),
});

// Export hooks for use in components
export const { useGetPointsQuery, useLazyGetPointsQuery } = pointsApi;